import { history } from "../redux";

const online = navigator.onLine ? true : false;

// util simples para procurar termos ignorando acentos/mojibake e maiúsculas
const includesAny = (text, needles = []) => {
  if (typeof text !== "string") return false;
  const t = text.toLowerCase();
  return needles.some((n) => t.includes(String(n).toLowerCase()));
};

const handleErrorStatus = (response, e422) => {
  const { status } = response;

  switch (status) {
    case 400:
      {
        const topMsg = response?.data?.message;
        const list = response?.data?.errors || [];
        const firstMsg = list.length ? list[0]?.message : null;
        const msg = topMsg || firstMsg || "";

        // Verifica se realmente é erro de autenticação
        if (includesAny(msg, ["invalid credentials", "login", "senha", "usuário inválido"])) {
          return "AuthError";
        }

        // Caso específico: arquivo já existe no storage do backend
        if (
          includesAny(msg, ["FileStorageException", "existe o arquivo", "existe o ficheiro", "file already exists"])
        ) {
          return "FileAlreadyExists";
        }
      }

      if (response.data.errors) {
        const errorMsg = response.data.errors.map(function (item) {
          switch (item.sqlState) {
            case "duplicateUsers":
              return "DuplicatedEmail";
            case "duplicateContact":
              return item;
            case "duplicatePlan":
            case "duplicateDepartment":
            case "duplicateTag":
              return "DuplicatedName";
            case "foreignKeyViolation":
              return "ForeignKeyViolation." + item.parameter;
            default:
              return "RandomError";
          }
        });
        return errorMsg;
      }
      return "BadRequest"; // Erro 400 bgenérico
    case 401:
      history.push("/401");
      window.location.reload();
      return {};
    case 403:
      return "Unauthorized";
    case 404:
      history.push("/404");
      window.location.reload();
      return {};
    case 422:
      const { errors } = response.data;
      if (errors && e422) {
        return errors;
      }
      return "InvalidData";
    case 500:
      if (response.data?.message === "fileSizeExceeded") {
        return "fileSizeExceeded";
      }
      if (response.data?.message === "bodyCharacterExceeded") {
        return "bodyCharacterExceeded";
      }
      //'Internal Server Error';
      return "RandomError";
    default:
      return {};
  }
};

const errorHandler = (error, e422 = true) => {
  const { response } = error;

  if (online) {
    if (response) {
      return handleErrorStatus(response, e422);
    }

    //BackendOff
    if (error.message === "Network Error") {
      localStorage.removeItem("authUser");
      history.push("/login");
      window.location.reload();
      return {};
    }

    return "RandomError";
  }
  return "Offline";
};

export default errorHandler;
